import RegraComissaoTecnicoService from "@/services/RegraComissaoTecnicoService";

export const regraComissaoTecnico = {
  namespaced: true,
  state: {
    regraComissaoTecnico: {},
  },
  actions: {
    getRegraComissaoTecnico({ commit }, payload) {
      return RegraComissaoTecnicoService.GetRegraComissaoTecnico(payload).then(
        (regraComissaoTecnico) => {
          return Promise.resolve(regraComissaoTecnico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRegraComissaoTecnico({ commit }, payload) {
      return RegraComissaoTecnicoService.PostRegraComissaoTecnico(payload).then(
        (regraComissaoTecnico) => {
          return Promise.resolve(regraComissaoTecnico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRegraComissaoTecnico({ commit }, payload) {
      return RegraComissaoTecnicoService.PutRegraComissaoTecnico(payload).then(
        (regraComissaoTecnico) => {
          return Promise.resolve(regraComissaoTecnico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRegraComissaoTecnico({ commit }, payload) {
      return RegraComissaoTecnicoService.DeleteRegraComissaoTecnico(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRegraComissaoTecnicoOData({ commit }, payload) {
      return RegraComissaoTecnicoService.GetRegraComissaoTecnicoOData(
        payload
      ).then(
        (regraComissaoTecnico) => {
          return Promise.resolve(regraComissaoTecnico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default regraComissaoTecnico;
